import React from 'react'

const FooterDesktop = () => {
  return (
    <footer className="bg-darkblue py-3">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p className="text-center color-white opacity-06"><small>© {new Date().getFullYear()} - Instituto Nacional de Educação a Distância - INED - Modernidade com Responsabilidade | Laudera Participações Ltda. CNPJ: 65.524.803/0001-90 - Todos os direitos reservados<br/>
            Endereço: Praça Marechal Deodoro, 356 - Santa Cecília - São Paulo - SP - CEP: 01150-010 - Telefone (11) 3823-2222<br/>
            Desenvolvimento: CloudDog</small></p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default function Footer () {
  return (
    <FooterDesktop />
  )
}
